export interface HeroSectionData {
  title: string
  titleHighlight: string
  subtitle: string
  image: string
  imageAlt: string
  paragraphs: string[]
}

export const heroSectionData: HeroSectionData = {
  title: 'AI in ',
  titleHighlight: 'Marketing',
  subtitle: 'Intelligent Solutions for Measurable Business Growth',
  image: '/assets/images/ai-in-marketing-hero.jpg',
  imageAlt: 'AI in Marketing',
  paragraphs: [
    'AI in marketing uses machine learning, behavioral analytics, and automation to detect, prevent, and respond to cyber and physical threats in real time. As enterprises expand across cloud, APIs, endpoints, and distributed systems, traditional rule-based security struggles to keep up with the scale and complexity of modern attacks.',
    'AI introduces a continuous intelligence layer that enables real-time anomaly detection, predictive threat analysis, and automated response. It helps Security Operations Centers (SOCs) cut through alert noise, improve detection accuracy, and significantly reduce response times.',
    'At WebClues Infotech, we build AI-based security solutions that shift enterprises from reactive monitoring to autonomous defense. From threat detection and SOC automation to fraud prevention, identity intelligence, and AI-powered surveillance, the focus is on creating scalable, intelligence-led security systems.',
  ],
}
